import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EnvironmentService } from 'src/app/services/environment.service';
import { NetzTranslateService } from 'src/app/services/netz-translate.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-server-maintenance-page',
  templateUrl: './server-maintenance-page.component.html',
  styleUrls: ['./server-maintenance-page.component.scss'],
})
export class ServerMaintenancePageComponent implements OnInit {
  isUserLoggedIn: boolean;

  constructor(
    private environmentService: EnvironmentService,
    private router: Router,
    private translationService: NetzTranslateService,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    this.isUserLoggedIn = !!this.userService.getUserStatus();
  }

  get underMaintenanceMessage() {
    let messageTempalte = this.translationService.translateString('error-page.server-under-maintenance');
    const clientName = this.translationService.translateString('app.client-name');

    return messageTempalte.replace('{clientName}', clientName);
  }

  openImprint(): void {
    const impressumRoute = this.environmentService.impressumRoute ?? '/impressum';

    if (this.isValidUrl(impressumRoute)) {
      window.open(impressumRoute);
      return;
    }

    this.router.navigate([impressumRoute]);
  }

  private isValidUrl(value: string) {
    let url: URL;

    try {
      url = new URL(value);
    } catch (_) {
      return false;
    }

    return url.protocol === 'http:' || url.protocol === 'https:';
  }
}
